module.exports = __webpack_public_path__ + "img/smile--pressed.24dfed8b.svg";